// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.Header_wrapper__1ZfjB {\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n  .Header_wrapper__1ZfjB h1 {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 32px;\n    color: #494949;\n    margin-bottom: 0; }\n  .Header_wrapper__1ZfjB.Header_hideAdd__1bpAY button {\n    visibility: hidden; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "Header_wrapper__1ZfjB",
	"hideAdd": "Header_hideAdd__1bpAY"
};
module.exports = exports;
